export default () => ({
  restrict: "A",
  link(scope, $elm, attrs) {
    const offset = attrs.scrollIntoViewOffset || 500;
    if (scope.$eval(attrs.scrollIntoView)) {
      setTimeout(() => {
        $elm[0].scrollIntoView();
        if (offset) {
          window.scrollBy(0, offset);
          console.warn("scrollIntoView", { attrs, offset });
        }
      }, attrs.scrollIntoViewDelay || 500);
    }
  },
});
